// extracted by mini-css-extract-plugin
export default {"report":"Report_report__XOa1K","header":"Report_header__PbpEb","child":"Report_child__gIXVJ"};